<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Sales
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col>-->
            <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.user_id"
                :items="driverItems"
                label="User"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.user_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.product_id"
                :items="productItems"
                label="Product"
                prepend-inner-icon="mdi-archive-star"
                clearable
                :error-messages="errors.product_id"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="is_recieved"
                outlined
                v-model="form.is_recieved"
                :items="isreceivedItems"
                label="is_received"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.is_recieved"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-archive-star"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.round_of_amount"
                outlined
                label="Round Of Amount"
                prepend-inner-icon="mdi-currency-rupee"
                :error-messages="errors.round_of_amount"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.driver_name"
                outlined
                label="Driver Name"
                prepend-inner-icon="mdi-card-account-details"
                :error-messages="errors.driver_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.driver_phone"
                outlined
                label="Driver Phone"
                prepend-inner-icon="mdi-card-account-details"
                :error-messages="errors.driver_phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.recieved_amount"
                outlined
                label="Recieved Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.balance_amount"
                outlined
                label="Balance Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.note"
                outlined
                label="Note"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.vehicle_registration_no"
                outlined
                label="Vehicle Registration No"
                prepend-inner-icon="mdi-car-back "
                :error-messages="errors.vehicle_registration_no"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.amount"
                outlined
                label="Amount"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.point_earned"
                outlined
                label="Point Earned"
                prepend-inner-icon="mdi-hand-coin"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.point_valid_till"
                    label="point valid till"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.point_valid_till"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <input
                type="file"
                id="document_path"
                name="document_path"
                ref="document_path"
                accept="image/*"
                @input="handleFileUpload"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Sales
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreCreatePage",
  data() {
    return {
      form: {
        store: "",
      },
      productItems: [],
      sale: [],
      storeItems: [],
      driverItems: [],
      isLoading: false,
      isreceivedItems: [
        { id: "YES", text: "YES", value: 1 },
        { id: "NO", text: "NO", value: 0 },
      ],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`sales/masters`)
        .then((masters) => {
          masters = masters.data;
          //Stores
          // masters.stores.forEach((store) => {
          //   this.storeItems.push({
          //     id: store.id,
          //     text: store.name,
          //     value: store.id,
          //   });
          // });
          //Users
          masters.users.forEach((user) => {
            this.driverItems.push({
              id: user.id,
              text: user.first_name,
              value: user.id,
            });
          });
          //Products
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        this.sale = await axios.post("/sales", this.form);
        await this.handleFileUpload();
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/sales");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      this.imagepath_attachment = this.$refs.document_path.files[0];
      formData.append("id", this.sale.data.data.id);
      formData.append("document_filepath", this.imagepath_attachment);
      await axios
        .post("upload_sale_images", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      // .then((response) => {
      //   if (response.data.data) this.user = response.data.data;
      //   this.is_Uploaded = true;
      // })
      this.isUploading = false;
    },
  },
};
</script>
